import { COVERAGE_DIMENSION_CODES } from '@shared/domain/coverageDimensions';
import type { CoverageDimensionScore } from '@shared/domain/coverageDimensions';

/** Demo coverage dimensions derived from graph analysis completeness (marketing site only). */
export function buildDemoCoverageDimensions(completeness: number): CoverageDimensionScore[] {
  const score = Math.max(0, Math.min(100, Math.round(completeness)));
  return COVERAGE_DIMENSION_CODES.map(code => ({
    code,
    score,
    reasoning: 'Demo coverage snapshot for hero animation.',
  }));
}
